export class OpportunitiesDTO {

	opportunityId = -1;
    salesRep ;
	sssOwnerName = '';
	ommsysNumber = '';
	createdDate = '';
	opportunityName= '' ;
	description= '' ;
	so= '' ;
	customerBudget= '' ;
	customerAuth= '' ;
	businessPartners= '' ;
	sboNumber: number;
	sbmchannel= '' ;
	expectedClosingDate : Date;
	customerTiming : Date ;
	dueDate : Date ;
	contactName= '' ;
	partenerName= '' ;
	confidential = false;
	sbo  = false;
	users: {userId: number,
		firstName : String,
			lastName : String};
	opportunitySource: {sourceId: number};
	sector: {sectorId: number};
	region: {regionId: number};
	customerNeed: {customerId: number};
	status: {statusId: number};
	customer: {customerId: number};
	renewable = false;
	userComments:[];
	techLead : {userId: number,
					firstName : String,
					lastName : String};

	constructor(){
		let sourceId = -1
		this.opportunitySource = {sourceId};

		let userId = -1;
		let firstName = "";
		let lastName = "";
		this.users = {userId , firstName, lastName};

		let sectorId = -1;
		this.sector = {sectorId};

		let regionId = -1;
		this.region = {regionId};

		let customerId = -1;
		this.customerNeed = {customerId};

		let statusId = -1;
		this.status = {statusId};

		this.customer = {customerId};
	}
    
}

export class OrderDTO 
{
    orderId: number;
    orderPrice: number;
    opportunity: {opportunityId:number};
    opportunityProduct: {productId:number};
    swgServiceAssetIncluded: boolean;
    swgServiceAssetName: number;
    swgServiceAssetVersion: string;
    swgServiceAssetId: string;
    stgServiceName: string;
    stgServiceValue: number
}
